export const RECUR_TYPE_LABEL = { monthly: 'รายเดือน', yearly: 'รายปี' };

export const THAI_MONTHS = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
];

export const THAI_MONTHS_SHORT = [
  'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
  'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.',
];

// ตัวแปรที่ใส่ในช่อง "รายการ" ของ template ได้ — แทนค่าตามงวดตอนกดสร้างรายการเบิก (ดู applyNameVars ใน utils.js)
export const NAME_VARIABLES = [
  { token: '{เดือน}', desc: 'ชื่อเดือนเต็ม', example: 'กันยายน' },
  { token: '{ด}', desc: 'ชื่อเดือนย่อ', example: 'ก.ย.' },
  { token: '{ปี}', desc: 'ปี พ.ศ. 2 หลัก', example: '69' },
  { token: '{ปีเต็ม}', desc: 'ปี พ.ศ. เต็ม', example: '2569' },
  { token: '{ยอด}', desc: 'ยอดจ่ายสุทธิที่กรอกตอนสร้าง', example: '8,618' },
];

// ตัวเลือกปีสำหรับกำหนดช่วงเวลาที่ให้เตือน (range_start/range_end) — ย้อนหลัง 2 ปี
// ล่วงหน้า 15 ปี กว้างพอสำหรับสัญญา/ประกันระยะยาวทั่วไป
const CURRENT_YEAR = new Date().getFullYear();
export const YEAR_OPTIONS = Array.from({ length: 18 }, (_, i) => CURRENT_YEAR - 2 + i);

// สีประจำฟีเจอร์ "รายการเบิกประจำ" — ม่วง→คราม เดียวกับ gradient ของแท็บ "รายการเบิกประจำ" ใน
// ExpensesList.js (TABS array) ใช้ผูก header modal / ปุ่มยืนยัน / การ์ดเลือกความถี่ให้เป็นชุดสีเดียวกัน
export const ACCENT_GRADIENT = 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)';
export const ACCENT_COLOR = '#7c6cf0';

export const MODAL_STYLE = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '92%', sm: '85%', md: '65%' },
  maxWidth: 760,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};
